// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageDiv {
    margin: 10px 0px;
}

.textDiv {
    margin: 11px;
    overflow: auto;
}

.innerTextDiv {
    white-space: normal;
    word-break: break-word;
}

.buttonStack {
    justify-content: flex-end;
    flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dialogs/messagebox/messagebox.dialog.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".imageDiv {\n    margin: 10px 0px;\n}\n\n.textDiv {\n    margin: 11px;\n    overflow: auto;\n}\n\n.innerTextDiv {\n    white-space: normal;\n    word-break: break-word;\n}\n\n.buttonStack {\n    justify-content: flex-end;\n    flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
